var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgX(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-.006.668L.7-.04l24.324 24.324-.707.707z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-.006 24.285L24.318-.039l.707.707L.701 24.992z"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNSIgaGVpZ2h0PSIyNSIgeD0iMCIgeT0iMCIgdmVyc2lvbj0iMS4xIiB2aWV3Qm94PSIwIDAgMjUgMjUiIHhtbDpzcGFjZT0icHJlc2VydmUiPgogIDxwYXRoIGQ9Ik0xMi00LjdoMXYzNC40aC0xeiIgdHJhbnNmb3JtPSJyb3RhdGUoLTQ1IDEyLjQ3NjQzMzE1IDEyLjQ3NjY2MTM5KSIvPgogIDxwYXRoIGQ9Ik0tNC43IDEyaDM0LjR2MUgtNC43eiIgdHJhbnNmb3JtPSJyb3RhdGUoLTQ1IDEyLjQ3NjQzMzE1IDEyLjQ3NjY2MTM5KSIvPgo8L3N2Zz4=";
export { SvgX as ReactComponent };